import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import "./Successfully.css"

const Successfully = () => {
 const navigate = useNavigate();
   const location = useLocation();
    const { data,type} = location.state;

  return (
    <div className={`message-page ${type}`}>
  <div className="message-box">
    <h1>{type}</h1>
    <p>{data}</p>
    <button onClick={() => navigate('/')}>Go Home</button>
  </div>
</div>
  )
}

export default Successfully